import { BookingStatus } from "utils/interfaces"
import { UNPAID_STATUSES } from "modules/ClientAccount/constants"

export function showPaymentBlock(bookingStatus: BookingStatus) {
    return UNPAID_STATUSES.some((s) => s === bookingStatus)
}
